export const PRODUCTION_STOP_REASON = 'ProductionStopReason';
/** Grid/form labels for `planned` — never show raw true/false. */
export const PRODUCTION_STOP_REASON_PLANNED_LABELS = {
    planned: 'Programada',
    unplanned: 'Não programada',
};
export function productionStopReasonPlannedLabel(planned) {
    return planned
        ? PRODUCTION_STOP_REASON_PLANNED_LABELS.planned
        : PRODUCTION_STOP_REASON_PLANNED_LABELS.unplanned;
}
//# sourceMappingURL=production-stop-reason.js.map